




























































import { Component, Prop, Vue } from 'vue-property-decorator'
import JSPDF from 'jspdf'

@Component({
  name: 'DownloadSeed',
  components: {}
})
export default class DownloadSeed extends Vue {
  @Prop(String) seed
  @Prop(String) publicKey

  t (key: string) {
    return this.$t(`DownloadSeed.${key}`)
  }

  phraseKey = 'Datei herunterladen';
  btnDisabled = true;
  displayMessage = false;

  downloadSeed () {
    const pdfName = 'seed-phrase-backup.pdf'
    const doc = new JSPDF()
    const header = doc.splitTextToSize('Brickwise Notar Seedphrase:', 90)
    const seed = doc.splitTextToSize(`Seed: ${this.seed}`, 180)
    const address = doc.splitTextToSize(`PublicKey: ${this.publicKey}`, 180)
    doc.text(header, 10, 10)
    doc.text(seed, 10, 35)
    doc.text(address, 10, 50)
    doc.save(pdfName)
    this.displayMessage = true
    this.btnDisabled = false
  }
}
